module.exports = __webpack_public_path__ + "static/media/fall.7bd526e4.svg";